import { get, post, del } from "./api_helper";

// Optional / permission-gated calls — opt out of the global auto-logout so a
// 401/403 ("feature unavailable") doesn't end the session.
const OPT = { skipAuthLogout: true };

// TOTP MFA (self-service) — /api/users/me/mfa/**
export const getMfaStatus = () => get("users/me/mfa", OPT);
export const mfaEnrollStart = () => post("users/me/mfa/enroll-start", {}, OPT);
export const mfaEnrollConfirm = ({ secret, code }) =>
  post("users/me/mfa/enroll-confirm", { secret, code }, OPT);

// API keys (tenant-scoped) — /api/companies/{id}/api-keys. Create/rotate return the
// plaintext key once.
export const listApiKeys = (companyId) =>
  get(`companies/${companyId}/api-keys`, OPT).then((res) =>
    Array.isArray(res) ? res : res?.content ?? []
  );
export const createApiKey = (companyId, { label, environment }) =>
  post(`companies/${companyId}/api-keys`, { label, environment, senderScope: "ALL" }, OPT);
export const rotateApiKey = (companyId, keyId) =>
  post(`companies/${companyId}/api-keys/${keyId}/rotate`, {}, OPT);
export const revokeApiKey = (companyId, keyId) =>
  del(`companies/${companyId}/api-keys/${keyId}`, OPT);
